import React from "react";
import {
  G2,
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Label,
  Legend,
  View,
  Guide,
  Shape,
  Facet,
  Util
} from "bizcharts";

class EquityChart extends React.Component {
  render() {
    const { data = [], title, height } = this.props;
    return (
      <div>
        <Chart height={height} data={data} forceFit>
          <div className='main-title' style={{textAlign: 'center', fontSize: 28}}>{title}</div>
          <Axis name="y" />
          <Axis name="x" />
          <Tooltip
            crosshairs={{
              type: "y"
            }}
          />
          <Geom type="line" position="y*x" size={2} />
          <Geom
            type="point"
            position="y*x"
            size={0}
            style={{
              stroke: "#fff",
              lineWidth: 0
            }}
          />
        </Chart>
      </div>
    );
  }
}

export default EquityChart;



// WEBPACK FOOTER //
// ./src/components/view-positions/EquityChart.js